import { memo, useEffect } from 'react'
import { useSelector } from 'react-redux'
import { dispatch } from 'store'
import { aiAvatarSelectors } from 'store/features/aiAvatar/selectors'
import { aiImageThunks } from 'store/features/aiImage/thunks'
import { AVATAR_PREVIEW_ACTIONS } from './config'
import UndoSourceImageButton from './components/buttons/UndoSourceImageButton'
import { ActionsRow } from '../styled'

// Overlay actions on the avatar preview: the top-right row of source-image
// actions (Resize / Enhance / Delete) plus the top-left one-step Undo (its own
// slot — state-scoped, not part of the source-scoped mapping; it self-hides
// when there's nothing to undo). Rendered only when the preview isn't loading
// (see AvatarPreview).
const AvatarActions = () => {
  const avatar = useSelector(aiAvatarSelectors.avatar)

  // Enhance/Resize read the source-image model (ratios + cost) from the aiImage
  // catalog; fetch it up front (idempotent) so the flyouts aren't empty on open.
  useEffect(() => {
    dispatch(aiImageThunks.getModels())
  }, [])

  return (
    <>
      <UndoSourceImageButton />
      <ActionsRow>
        {AVATAR_PREVIEW_ACTIONS.filter(action =>
          action.isVisible(avatar?.source)
        ).map(({ key, Component }) => (
          <Component key={key} />
        ))}
      </ActionsRow>
    </>
  )
}

export default memo(AvatarActions)
